import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"
import FileUploadGroupBuilder from "../../FileUploadGroupBuilder/FileUploadGroupBuilder"

class NotePresenterGeneral extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    $('#note').append(`${this.props.note.note}`)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">

        <div className="row">

          <div className="col-md-12">

            <div className='panel panel-default'>

              <div className="panel-heading">
                <h3 className="panel-title">
                  {I18n.t('notes')}
                </h3>
              </div>
              <div className="panel-body">

                {this.renderNotes()}
                {this.renderFlagged()}

              </div>
            </div>
          </div>

        </div>
        <br />
        <div className="row">
          {this.renderFileUploadGroupBuilder()}
        </div>
      </div>
    )
  }

  renderNotes() {
    return (
      <div className="notes">
        <div className="col-md-12">
          <div className="form-group">
            <div id="note" style={{ 'whiteSpace': 'pre-line' }}>
              {/* append note here */}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFlagged() {
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label>{I18n.t('flagged')}</label> <span className="ss-help help" title={I18n.t('flagged_helper_text')}></span>
          <br />
          {this.props.note.flagged ? I18n.t('yes') : I18n.t('no')}
        </div>
      </div>
    )
  }

  renderFileUploadGroupBuilder() {
    return (
      <div className="col-md-12">
        <FileUploadGroupBuilder nested={true} read_only={true} file_upload_groups={this.props.file_upload_group ? [this.props.file_upload_group] : [{ file_uploads: [] }]} />
      </div>
    )
  }
}

export default NotePresenterGeneral